jQuery(document).ready(function() {

    var pikaday_i18n = {
        previousMonth : 'Vorige maand',
        nextMonth     : 'Volgende maand',
        months        : ['Januari','Februari','Maart','April','Mei','Juni','Juli','Augustus','September','Oktober','November','December'],
        monthsShort   : ['Jan','Feb','Mrt','Apr','Mei','Jun','Jul','Aug','Sep','Okt','Nov','Dec'],
        weekdays      : ['Zondag','Maandag','Dinsdag','Woensdag','Donderdag','Vrijdag','Zaterdag'],
        weekdaysShort : ['Zo','Ma','Di','Wo','Do','Vr','Za']
    }

    var picker = [],
        today = new Date();

    $('.datepicker').each(function(idx) {
        picker[idx] = new Pikaday({
            field: $(this).find('input')[0],
            bound: false,
            container: $(this)[0],
            format: 'l', // uncomment to enable pretty date format
            // showWeekNumber: true, // if enabled, update weekend highlighting CSS
            minDate: new Date(),
            maxDate: new Date(2021, 12, 31),
            defaultDate: new Date( moment().day(6).format("YYYY, MM, DD") ), // auto-select next saturday
            setDefaultDate: true,
            i18n: pikaday_i18n,
            onSelect: function() {
                var $elem = $(this.el);

                // if datepicker is in dropdown-window, close it
                if( $elem.closest('.dropdown-window__content').length ) {
                    var $window_content = $elem.closest('.dropdown-window__content');

                    if( $window_content.hasClass('dropdown-window__content--visible') ) {
                        $window_content.removeClass('dropdown-window__content--visible');
                    }
                }
            }
        });
    });


    // hidden input with datepickers
    $('.input-wrapper.datepicker input[type="hidden"]').change( function() {
        var newVal = $(this).attr('value');
        $(this).closest('.form-field').find('.form-field__fake-input .field-text').html(newVal);
    });

});